import { render, staticRenderFns } from "./logsqladd.vue?vue&type=template&id=41a4d192&"
import script from "./logsqladd.vue?vue&type=script&lang=js&"
export * from "./logsqladd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports